<div class="row">
    <div class="col-lg-8">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="false"
                        [showEdit]="false"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    @if (canEdit) {
                        <button type="button" class="btn btn-secondary btn-sm ms-2" (click)="backfillRecipients()">
                            Backfill missed inbox rows
                        </button>
                    }
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    (initialized)="grid.initialize(mainGrid)"
                    [itemsSource]="grid.view"
                    (selectionChanged)="getRecipients()"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Sent On'"
                        [binding]="'sentDate'"
                        [width]="175"
                        [format]="'MM/dd/yyyy hh:mm tt'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Expires On'"
                        [binding]="'expiresOn'"
                        [width]="130"
                        [format]="'MM/dd/yyyy'"
                        [isReadOnly]="!canEdit"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Sent By'"
                        [binding]="'sentByUserId'"
                        [dataMap]="usersDataMap"
                        [width]="185"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="250" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Body'" [binding]="'body'" [width]="'2*'" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>

    <div class="col-lg-4" [hidden]="!grid.selectedItem">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="usersGrid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="usersGrid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridUsers"
                    #gridUsers
                    appAutoSize
                    (initialized)="usersGrid.initialize(gridUsers)"
                    [itemsSource]="usersGrid.view"
                    (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Recipient'"
                        [binding]="'displayName'"
                        [width]="'*'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Viewed'" [binding]="'viewed'" [width]="100"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Viewed Date'"
                        [binding]="'viewedDate'"
                        [width]="175"
                        [format]="'MM/dd/yyyy hh:mm tt'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
